import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { IconPack, library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import * as am4core from '@amcharts/amcharts4/core';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import UserAuth from '@services/auth';
import theme from '@theme/theme-rtl';
import RouteLayout from '@routes/RouteLayout';
import useUserDetails from '@hooks/useUserDetails';
import { RootState } from '@store/store';
import './App.css';
import { initAmplitude } from '@utils/amplitude';
import { initGA } from '@utils/googleAnalytics';
import { NotificationReciever } from '@components';

library.add(fas as IconPack, far as IconPack, fab as IconPack);
am4core.options.queue = true;

const App: React.FC = () => {
  const user = UserAuth.userInfo;
  const { getUserDetails } = useUserDetails();

  const loginData = useSelector((state: RootState) => state?.loginData);

  useEffect(() => {
    initAmplitude();
    initGA();
  }, []);

  useEffect(() => {
    const userId = loginData.user.id || user?.id;

    if (UserAuth.isAuthenticated && userId) getUserDetails(userId as string);
  }, [loginData.user.id, user?.id]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastContainer
          position='top-right'
          autoClose={6000}
          newestOnTop={false}
          closeOnClick={false}
          closeButton={false}
          hideProgressBar
          draggable
        />
        <CssBaseline />
        <RouteLayout />
      </ThemeProvider>
      <NotificationReciever />
    </>
  );
};

export default App;
